export const GET_DOCTOR_APPOINTMENTS = "GET_DOCTOR_APPOINTMENTS";
export const ADD_APPOINTMENT = "ADD_APPOINTMENT";
export const EDIT_APPOINTMENT = "EDIT_APPOINTMENT";
export const REMOVE_APPOINTMENT = "REMOVE_APPOINTMENT";
export const GET_APPOINTMENT = "GET_APPOINTMENT";

export const getAppointment = (appointment) => ({
  type: GET_APPOINTMENT,
  appointment: appointment,
});

export const getDoctorAppointment = (appointments) => {
  return {
    type: GET_DOCTOR_APPOINTMENTS,
    appointments: appointments,
  };
};

export const addAppointment = (appointment) => {
  return {
    type: ADD_APPOINTMENT,
    appointment: appointment,
  };
};

export const editAppointment = (appointment) => {
  return {
    type: EDIT_APPOINTMENT,
    appointment: appointment,
  };
};

export const removeAppointment = (appointment) => {
  return {
    type: REMOVE_APPOINTMENT,
    appointment: appointment,
  };
};
